<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'DistributorOrderList' }">
          待办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <do-it-action-box v-if="baseInfo" :base-info="baseInfo" />
    <base-info :document-i-d="documentID" @initedBaseInfo="initedBaseInfo" />
    <subject-product v-if="baseInfo" :document-i-d="documentID" :base-info="baseInfo" />
  </div>
</template>
<script type="es6">
import baseInfo from '../handlePrice/baseInfo';
import doItActionBox from './doItActionBox';
import SubjectProduct from './SubjectProduct';
export default {
  data () {
    return {
      tabsActive: '1',
      baseInfo: null
    };
  },
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  components: {
    baseInfo,
    doItActionBox,
    SubjectProduct
  },
  computed: {},
  methods: {
    initedBaseInfo (val) {
      this.baseInfo = val;
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss"></style>
